// Artisan Bites — menu content sourced from the brand catalogue.
export const CATEGORIES = [
  {
    id: "filled-cookies",
    index: "01",
    name: "Signature Filled Cookies",
    tagline: "Molten cores, soft-baked shells",
    format: "Frozen · Bake-off",
    image: "/products/filled-cookiese2.jpg",
    items: [
      { name: "Original New York Style Cookie", desc: "A soft-baked cookie hiding a molten salted-caramel core." },
      { name: "Milk Chocolate New York Style", desc: "Chocolate-filled indulgence with a slow, gooey centre." },
      { name: "Salted Caramel Twix", desc: "Buttery dough layered with salted caramel and chocolate." },
    ],
  },
  {
    id: "cookie-pots",
    index: "02",
    name: "Individual Cookie Pots",
    tagline: "Warm, gooey, spoonable",
    format: "Frozen · Bake-off",
    image: "/products/cookie-pots.jpg",
    items: [
      { name: "Classic Cookie Pot", desc: "The signature cookie, baked to order and served warm in its pot." },
      { name: "Triple Chocolate Cookie Pot", desc: "Three chocolates folded through a molten, spoonable centre." },
    ],
  },
  {
    id: "desserts",
    index: "03",
    name: "Individual Desserts",
    tagline: "Plated finesse, portioned for service",
    format: "Chilled",
    image: "/products/desserts.jpg",
    items: [
      { name: "San Sebastián Cheesecake Cup", desc: "Burnt-top Basque cheesecake, caramelised and creamy." },
      { name: "Le Chocolat Parisien", desc: "Dark chocolate mousse with a deep cocoa finish." },
      { name: "Classic Tiramisu", desc: "Espresso-soaked sponge, mascarpone, dusted cocoa." },
      { name: "Sticky Toffee Pudding", desc: "Date sponge drenched in warm toffee sauce." },
      { name: "Coconut, Mango & Passionfruit", desc: "Tropical layers, bright and clean." },
      { name: "Banana Pudding", desc: "Nostalgic layers of custard, banana and crumb." },
    ],
  },
  {
    id: "cakes-loaves",
    index: "04",
    name: "Cakes & Loaves",
    tagline: "Bake, slice, serve",
    format: "Ambient",
    image: "/products/cakes-loaves.jpg",
    items: [
      { name: "Classic Banana Bread", desc: "Dense, moist and generously spiced." },
      { name: "Lemon Cake", desc: "Zesty, tender crumb with a bright citrus glaze." },
      { name: "Vanilla Latte Streusel Cake", desc: "Coffee-kissed sponge under a buttery streusel." },
    ],
  },
  {
    id: "savoury",
    index: "05",
    name: "Savoury Bakery",
    tagline: "Golden, herbed, shareable",
    format: "Frozen · Bake-off",
    image: "/products/savoury.jpg",
    items: [
      { name: "Garlic Cheese Bun", desc: "Pillowy bun loaded with garlic butter and melted cheese." },
      { name: "Cheese & Herb Focaccia", desc: "Olive-oil crumb, sea salt and fresh herbs." },
      { name: "Spinach & Feta Roll", desc: "Flaky pastry wrapped around spinach and salty feta." },
    ],
  },
  {
    id: "oat-mix",
    index: "06",
    name: "Overnight Oat Mix",
    tagline: "Just add milk",
    format: "Ambient · Ready-to-hydrate",
    image: "/products/oat-mix.jpg",
    items: [
      { name: "Base Mix for Overnight Oats", desc: "A ready-to-hydrate breakfast base built for café and hotel service." },
    ],
  },
];
